module.exports = __webpack_public_path__ + "img/已认证.c8120923.png";